module.exports = __webpack_public_path__ + "static/media/magniWhite.b54d362e.svg";